import { Trans } from '@lingui/react/macro';

import { Link2 } from 'src/components/Link2';
import { useFeatureFlags } from 'src/utils/useFeatureFlags';

export function PromotionCheckoutLink({
  componentLocation,
}: {
  componentLocation: string;
}) {
  const featureFlags = useFeatureFlags();
  if (!featureFlags.EnableCheckoutV2 || !featureFlags.EnablePromoCodeLink) {
    return null;
  }

  return (
    <Link2
      as="button"
      to="/store/checkout"
      data-cy="promotion-checkout-link"
      componentLocation={componentLocation}
      variant="tertiary-neutral"
    >
      <Trans>I have a promo code</Trans>
    </Link2>
  );
}
